import { useMemo } from 'react'

type MiddleEllipsisProps = {
  text: string
  tailChars?: number
  className?: string
}

/**
 * Middle-ellipsis text. Always shows the trailing `tailChars` characters; the
 * leading portion clips with an end-ellipsis so the result reads as
 * "Launch Timel…tudio" once it overflows its container. Includes a native
 * `title` tooltip for the full text.
 */
export const MiddleEllipsis = ({ text, tailChars = 6, className }: MiddleEllipsisProps) => {
  const [head, tail] = useMemo(() => {
    if (text.length <= tailChars) return ['', text]
    return [text.slice(0, text.length - tailChars), text.slice(-tailChars)]
  }, [text, tailChars])

  return (
    <span className={`middleEllipsis ${className ?? ''}`} title={text}>
      <span className="middleEllipsis__start">{head}</span>
      <span className="middleEllipsis__end">{tail}</span>
    </span>
  )
}
